import { SetStateAction, useState } from 'react';
import CustomSelect from '../../../../../components/common/SelectField';
import { Grid, MenuItem, Tooltip } from '@mui/material';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { TableInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import moment from 'moment';
import AutocompleteMuiCustom from '../../../../../components/common/AutocompleteMuiCustom';
import { TimePicker } from '@mui/x-date-pickers';
import {
  AddIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import { convToTime } from '../../../../../utils/helpers';
import Operator from '../../../components/Operator';
import OperationSelect from '../OperationSelect';
import ModalCustom from '../../../../../components/common/Modal';
import OperatorFor4mLogs from './OperatorFor4mLogs';
interface IProps {
  moduleData: any;
  isView: boolean;
  handleSumbit: any;
  machineData: any;
  handelDeleteRows: any;
  isOpenPopup: any;
  setIsOpenPopup: any;
  setPartIdx: any;
}

// a and b is target production and actual production
function calcTotalQty(
  a: number | null | undefined,
  b: number | null | undefined,
): number | null {
  if (a === null || b === null || a === undefined || b === undefined) {
    return null;
  }
  return a - b;
}
function total(moduleData: any, name: string): number {
  let totalValue = 0;
  if (moduleData) {
    moduleData.processes.forEach((value: any) => {
      if (value[name]) {
        totalValue = totalValue + +value[name] || 0;
      }
    });
  }
  return totalValue;
}

const TBody = ({
  moduleData,
  isView,
  handleSumbit,
  machineData,
  handelDeleteRows,
  isOpenPopup,
  setIsOpenPopup,
  setPartIdx,
}: IProps) => {
  const [render, setRender] = useState(false);
  const [isOpen4mModel, setIsOpen4mModel] = useState(false);
  const [modalIdx, setModalIdx] = useState<any>(null);
  return (
    <>
      <tbody>
        {moduleData &&
          moduleData.processes.map((process: any, index: number) => (
            <tr key={index + 'module data'}>
              <td width={'100px'} style={{ fontWeight: 'bold' }}>
                {index + 1}
              </td>
              <td style={{ fontWeight: 'bold', minWidth: '100px' }}>
                {moduleData?.shift}
              </td>
              <td style={{ minWidth: '130px' }}>
                {/* {isView ? ( */}
                {process.shift === 'DAY' ? '' : process.shift}
                {/* ) : (
                  <CustomSelect
                    name="shift"
                    value={process.shift || ''}
                    onChange={(e) => {
                      handleChangeModuleData(e, process);
                      setRender((prev) => !prev);
                    }}
                  >
                    <MenuItem value="A">A</MenuItem>
                    <MenuItem value="B">B</MenuItem>
                  </CustomSelect>
                )} */}
              </td>
              <td style={{ minWidth: '250px' }}>
                {isView
                  ? process?.mc_no?.machine_no
                  : moduleData.dailyProduction_date &&
                    process.part_id && (
                      <AutocompleteMuiCustom
                        id="Machine"
                        label=""
                        option_name="machine_no"
                        option_name_2={'plant_location'}
                        arrayofObj={machineData}
                        value={process.mc_no_temp || process?.mc_no || ''}
                        onChange={(e, value) => {
                          process.mc_no = value._id;
                          process.mc_no_temp = value;
                          setRender((prev) => !prev);
                        }}
                      />
                    )}
              </td>
              <td style={{ minWidth: '200px' }}>
                {process.mc_no && moduleData.dailyProduction_date && (
                  <Operator
                    onSubmit={handleSumbit}
                    field="operator_name"
                    machineId={process?.mc_no?._id || process.mc_no}
                    dataObj={{
                      date: moduleData.dailyProduction_date,
                      part_id: process.part_id,
                      operation_name: process.operation_name,
                    }}
                    {...{ isView, process }}
                  />
                )}
              </td>
              <td style={{ width: '250px', minWidth: '250px' }}>
                {isView ? (
                  process?.part_id && process?.part_id?.part_name
                ) : (
                  <Grid container xs={12} direction="row" alignItems={'center'}>
                    <Grid item xs={10}>
                      <p
                        style={{
                          fontSize: '1.6rem',
                        }}
                      >
                        {typeof process?.part_id === 'object' &&
                        process?.part_id !== null
                          ? process?.part_id?.part_name
                          : process?.partName || ''}
                        {!process?.part_id && 'Pick Part Name'}
                      </p>
                    </Grid>

                    {process.part_id ? (
                      <Grid item xs={2}>
                        <RemoveIconButton
                          tooltipTitle="remove part"
                          onClick={() => {
                            process.part_id = null;
                            process.partNumber = null;
                            process.partName = null;
                            setRender((prev) => !prev);
                          }}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={2}>
                        <AddIconButton
                          tooltipTitle="add part"
                          onClick={() => {
                            setIsOpenPopup(true);
                            setPartIdx(index);
                          }}
                        />
                      </Grid>
                    )}
                  </Grid>
                )}
              </td>
              <td style={{ minWidth: '200px' }}>
                <OperationSelect
                  {...{ process, isView, setRender }}
                  partId={
                    typeof process.part_id === 'string'
                      ? process?.part_id
                      : process?.part_id?._id
                  }
                />
              </td>
              <td style={{ minWidth: '150px' }}>
                {isView ? (
                  convToTime(process.time_start)
                ) : (
                  <TimePicker
                    ampm={false}
                    value={moment(process.time_start)}
                    onChange={(date: any) => {
                      process.time_start = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '150px' }}>
                {isView ? (
                  convToTime(process.time_stop)
                ) : (
                  <TimePicker
                    ampm={false}
                    value={moment(process.time_stop)}
                    onChange={(date: any) => {
                      process.time_stop = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '100px' }}>
                <TableInput
                  isView={isView}
                  name="target_prod"
                  type="number"
                  value={process.target_prod}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '100px' }}>
                <TableInput
                  isView={isView}
                  name="actual_prod"
                  type="number"
                  value={process.actual_prod}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '100px' }}>
                <TableInput
                  isView={isView}
                  name="ok_qty"
                  type="number"
                  value={process.ok_qty}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '180px' }}>
                <TableInput
                  isView={isView}
                  name="reason_of_loss"
                  type="text"
                  value={process.reason_of_loss}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '120px' }}>
                {calcTotalQty(process.actual_prod, process.ok_qty)}
              </td>
              <td style={{ minWidth: '150px' }}>
                <TableInput
                  isView={isView}
                  name="rejection_details"
                  type="text"
                  value={process.rejection_details}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '200px' }} colSpan={isView ? 3 : 1}>
                <TableInput
                  isView={isView}
                  name="remarks"
                  type="text"
                  value={process.remarks}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              {!isView && (
                <td style={{ minWidth: '100px' }}>
                  <AddIconButton
                    tooltipTitle={'Add To 4M'}
                    onClick={() => {
                      setModalIdx(index);
                      setIsOpen4mModel(true);
                    }}
                  />
                </td>
              )}
              {!isView && (
                <td style={{ minWidth: '100px' }}>
                  <DeleteIconButton
                    tooltipTitle={'delete'}
                    onClick={() => handelDeleteRows(index)}
                  />
                </td>
              )}
            </tr>
          ))}
      </tbody>
      <tr>
        <th colSpan={18} align="left">
          Total Target: {total(moduleData, 'target_prod')}
        </th>
      </tr>
      <tr>
        <th colSpan={18} align="left">
          Total Actual Prod.: {total(moduleData, 'actual_prod')}
        </th>
      </tr>
      <tr>
        <th colSpan={18} align="left">
          Total Ok Qty.: {total(moduleData, 'ok_qty')}
        </th>
      </tr>
      <ModalCustom
        title="SUMMARY DATA"
        openModal={isOpen4mModel}
        closeModal={() => {
          setIsOpen4mModel(false);
        }}
      >
        <OperatorFor4mLogs
          onSubmit={handleSumbit}
          field="operator"
          machineId={moduleData?.processes?.[modalIdx]?.mc_no?._id}
          dataObj={{
            date: moduleData?.dailyProduction_date,
            part_id: moduleData?.processes?.[modalIdx]?.part_id,
            operation_name: moduleData?.processes?.[modalIdx]?.operation_name,
          }}
          process={moduleData?.processes?.[modalIdx]}
          {...{ isView, isOpen4mModel, setIsOpen4mModel }}
        />
      </ModalCustom>
    </>
  );
};

export default TBody;
